export type OrderModes = 'row' | 'column';

export enum DerivativeOrderTypeEnum {
  OPEN_ORDERS = 'OPEN_ORDERS',
  ORDERS_HISTORY = 'ORDERS_HISTORY',
  OPEN_POSITIONS = 'OPEN_POSITIONS',
  POSITIONS_HISTORY = 'POSITIONS_HISTORY',
  // ASSETS = 'ASSETS',
}
